
export const lmFilterClearClickFunction = (
  event: any,
  filterLookup: SohoLookupStatic,
  clearArguments: FilterClearFunctionClickArguments
) => {

  if (clearArguments === undefined) {
    return;
  }

  const listGridComponent = clearArguments.grid.settings.userObject();
  const column = clearArguments.column;

  if (!column.displayField || !column.displayField.compactFormatByForm) {
    return;
  }

  const listFilterClearClickedEvent: LMListFilterClearClickedEvent = {
    filterLookup,
    column
  };

  listGridComponent.listFilterClearClicked.emit(listFilterClearClickedEvent);
};
